import {CellSpanInfo} from '../types';

/**
 * Returns a filtered list of cell span infos given the
 * @param cellSpanInfos Cell span infos to be filtered or undefined
 * @param fixedColumnIndex Index of last column to be fixed (ie. not draw cell spans)
 * @param colCount Total number of columns, also including fixed columns
 * @returns Undefined if no cellspan infos are returned, otherwise returns filtered cell span infos
 */
export const getFilteredCellSpanInfos = <TCellSpanData = any>(
  cellSpanInfos: CellSpanInfo<TCellSpanData>[] | undefined,
  fixedColumnIndex: number | undefined = 0,
  colCount: number,
): CellSpanInfo<TCellSpanData>[] | undefined => {
  if (!cellSpanInfos) {
    return undefined;
  }

  const retVal = cellSpanInfos.filter(ci => {
    return (
      // Filter out elements ending before first regular column
      (ci.start + ci.length <= fixedColumnIndex + 1 ||
        // Filter out elements starting after last column
        ci.start >= colCount) === false
    );
  });

  return retVal.length > 0 ? retVal : undefined;
};
